<template>
    <el-dialog :visible.sync="dialogFormVisible"
               width="80%"
               :close-on-click-modal="false"
               :before-close="handleClose"
               class="meeting-view-dialog"
    >

        <div slot="title" class="dialog-title">
            <small class="text-info font-weight-bold">{{ $t('TITLE.'+(single.status?single.status.toUpperCase():'')) }} </small> | <b>{{ single.topic }} </b>
        </div>
        <el-tabs v-model="tab_index" class="position-relative">
            <!-- 会议信息 -->
            <el-tab-pane :label="$t('TITLE.MEETING.INFO')" name="1" class="tab-content">
                <el-row :gutter="20">
                    <el-col >
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.MEETING.ID')}}:</div>
                            <div class="page-content">{{ single.meeting_id || $t('TITLE.MEETING.NOT-CREATED') }}</div>
                        </div>
                    </el-col>
                    <el-col >
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.MEETING.START-TIME')}}:</div>
                            <div class="page-content">{{ single.start_time }}
                                ({{ single.duration }} {{$t('TITLE.MEETING.MINUTES')}})
                            </div>
                        </div>
                    </el-col>
                    <el-col >
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.PASSWORD')}}:</div>
                            <div class="page-content"><b>{{ single.password ? single.password : '' }}</b> <span
                                v-if="single.hostkey"
                                class="text-danger"> | {{$t('TITLE.MEETING.HOSTKEY')}}:{{ single.hostkey }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col >
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.MEETING.HOST')}}:</div>
                            <div class="page-content">{{ single.visitor_name }} </div>
                        </div>
                    </el-col>
                    <el-col v-if="single.cohost">
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.MEETING.COHOST')}}:</div>
                            <div class="page-content">{{ single.cohost }}</div>
                        </div>
                    </el-col>
                </el-row>
                <div class="clearfix mb-3"></div>
                <el-row>
                    <el-col >
                        <div class="d-flex">
                            <div class="page-label">{{$t('TITLE.OPTIONS')}}:</div>
                            <div class="page-content">
                                <span class="meeting-option" v-if="single.option_waiting_room">
                                <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.WAITING_ROOM')}} </span>
                                <span class="meeting-option" v-if="single.option_jbh">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.JBH')}} </span>
                                <span class="meeting-option" v-if="single.option_live_streaming">
                                    <i class="el-icon-check"></i>  {{$t('MESSAGE.OPTIONS.LIVE_STREAM')}} </span>
                                <span class="meeting-option" v-if="single.option_member_only">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.MEMBER_ONLY')}} </span>
                                <span class="meeting-option" v-if="single.option_auto_recording === 1">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.AUTO_RECORDING.LOCAL')}} </span>
                                <span class="meeting-option" v-if="single.option_auto_recording === 2">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.AUTO_RECORDING.CLOUD')}} </span>
                                <span class="meeting-option" v-if="single.option_water_mark === 1">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.WATERMARK.SINGLE')}} </span>
                                <span class="meeting-option" v-if="single.option_water_mark === 2">
                                    <i class="el-icon-check"></i> {{$t('MESSAGE.OPTIONS.WATERMARK.MULTI')}} </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="clearfix mb-3"></div>
                <el-row :gutter="20" v-if="single.join_url">
                    <el-col :span="24">
                        <div class="d-flex grey">
                            <div class="page-label">{{$t('TITLE.MEETING.JOIN-URL')}}:</div>
                            <div class="page-content">
                                <el-link :underline="false" class="pull-right ml-3" icon="el-icon-document-copy"
                                         @click="handleCopyMeetingInfo()" type="info"> {{$t('TITLE.MEETING.COPY-LINK')}}
                                </el-link>
                                <a :href="single.join_url" target="_blank" style="display: inline"> <i
                                    class="el-icon-link"></i> {{ single.join_url }}</a>
                            </div>
                        </div>
                    </el-col>
                    <el-col v-if="single.streaming">
                        <div class="d-flex grey">
                            <div class="page-label">{{$t('TITLE.MEETING.STREAMING')}}:</div>
                            <div class="page-content">
                                <a :href="single.streaming" target="_blank"> <i class="el-icon-link"></i>
                                    {{ single.streaming }}</a>
                            </div>
                        </div>
                    </el-col>
                    <el-col >
                        <div class="d-flex grey">
                            <div class="page-label">{{$t('TITLE.LOCATION')}}:</div>
                            <div class="page-content">
                                {{ single.location }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <!--周期性会议的详细情况-->
            <el-tab-pane label="周期信息" name="2" v-if="single.recurrent_info" class='tab-content'>
                <div class="font-weight-bold">
                    开始日期: {{ single.recurrent_info.date_start }} 结束时间: {{ single.recurrent_info.date_end }}
                    {{ single.recurrent_info.repeat | repeatMeaning }}
                    <span v-if="single.recurrent_info.original">
                    <br/> 建会账户: ({{ single.recurrent_info.original }})</span>
                </div>
                <div class="clearfix mb-3"></div>
                <el-table
                    size="mini"
                    :data="single.recurrent_info.meeting_times"
                    :default-sort="{prop: 'date', order: 'asc'}"
                    empty-text="没有数据。"
                >
                    <el-table-column
                        label="开始时间"
                        prop="time">
                        <template slot-scope="props">
                            {{ props.row.time.substr(0, 19) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="结束时间"
                        prop="time">
                        <template slot-scope="props">
                            {{ props.row.time.substr(-19) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="状态"
                        prop="time">
                        <template slot-scope="props">
                            <span
                                :class="props.row.date >= new Date().Format('yyyy-MM-dd')?'text-primary':'text-muted'">
                                {{ props.row.time | meetingStatues }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <!--会议的报表-->
        </el-tabs>

        <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="$emit('cancel')" icon="el-icon-close" class="mx-1">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "meeting-view",
    data() {
        return {
            poll_view: false,
            poll_data: {},
            dialogFormVisible: false,
            approve_form: {approve_result: '2'},
            qrcode: null,
            previewImage: null,
            invitation: false,
            tab_index: "1",
            meeting: {},
            record_tab:'1',
        }
    },
    props: {
        view_mode: {
            type: [Number, Boolean],
            default() {
                return false;
            }
        },
        rebuild: {
            type: Boolean,
            default() {
                return false;
            }
        },
        single: {
            type: Object,
            default() {
                return {};
            }
        },
        btn_start_meeting: {
            type: Boolean,
            default() {
                return true;
            }
        },
        btn_approve: {
            type: [Boolean, Number],
            default() {
                return false;
            }
        },
        btn_modify: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_delete: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_poll: {
            type: Boolean,
            default() {
                return false;
            }
        },
        mobile: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    computed: {
        emails() {
            let data = [];
            if (this.single.attendees) {
                try {
                    data = JSON.parse(this.single.attendees);
                } catch (e) {
                    console.log(e)
                }
            }
            return data;
        },
    },

    watch: {
        view_mode: {
            handler(newVal) {
                this.dialogFormVisible = !!newVal;
                this.tab_index = "1";
                this.record_tab = "1";
            }
        },
    },
    filters: {
        repeatMeaning(value) {
            if (value == '1') return '每天循环';
            if (value == '2') return '每周循环';
            if (value == '3') return '每月循环';
            return '不重复';
        }
    },
    methods: {
        jumpUrl(url) {
            window.open(url, "_blank");
        },
        copyClipboard(str) {
            this.$copyText(str).then(() => {
                this.$notice.success(this.$t('MESSAGE.CLIPBOARD.COPIED'));
            }).catch(() => {
                this.$notice.error(this.$t('MESSAGE.CLIPBOARD.FAILED')); //'复制失败,请手动复制');
            });
        },
        handleCopyMeetingInfo() {
            const str = "请参加视频会议 \n"
                + "会议主题：" + this.single.topic + "\n "
                + "会议时间：" + this.single.start_time + " (" + this.single.duration + "分钟)\n"
                + "点击链接入会，或添加至会议列表：\n"
                + this.single.join_url + "\n"
                + "\n#"+this.meeting_type+"：" + this.single.meeting_id + "\n"
                + "会议密码：" + (this.single.password ? this.single.password : "无" );
            this.copyClipboard(str);
        },

        handleClose(done) {
            done();
            this.$emit('cancel');
        },
    }
}
</script>

<style lang="scss">

.meeting-view-dialog {
    .el-dialog__body {
        padding: 10px 20px !important;
    }

    .tab-content {
        height: calc(75vh - 186px);
        overflow-x: hidden;
        overflow-y: auto;
    }

    .copy-btn {
        padding: 2px 5px;
    }

    .dialog-title {
        margin-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .page-label {
        flex: 0 0 160px;
        width: 160px;
        text-align: left;
        font-weight: bold;
        display: inline-block;
        line-height: 30px;
        background-color: aliceblue;
        padding: 0 5px;
        border-bottom: solid 1px darken(#b2ebf2, 20%);
    }

    .page-content {
        flex: 1;
        text-align: left;
        padding-left: 10px;
        display: inline-block;
        line-height: 30px;
        border-bottom: solid 1px #b2ebf2;
        overflow: hidden;
        padding-right: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;

        a {
            text-decoration: none;
            cursor: pointer;
        }
    }

    .grey {
        .page-label {
            background-color: #EEEEEE;
            border-bottom: solid 1px darken(#eeeeee, 20%);
        }

        .page-content {
            background-color: #f8f8f8;
            border-bottom: solid 1px #dddddd;
        }
    }

    .yellow {
        .page-label {
            background-color: #fffce2;
            border-bottom: solid 1px darken(#e4e2c7, 20%);
        }

        .page-content {
            background-color: #FFFEF5;
            border-bottom: solid 1px #e4e2c7;
        }
    }
}

.meeting-option {
}

ul.meeting-summary {
    list-style: auto;

    li {
        display: inline-block;
        margin-right: 20px;
    }
}

.approve_form {
    margin-top: 20px;
    padding: 10px 20px 5px;
    background-color: #FFFDE7;
    text-align: center;

    .el-form-item {
        margin-bottom: 0;
    }
}

.qrcode {
    height: 120px;
    width: 120px;
}

.view-attendee-block {
    display: inline-block;
    color: #333;
    padding: 2px 5px 2px 0;
    transition: all 0.2s ease-in;
    margin-right: 3px;
    cursor: pointer;

    &:hover {
        color: #2196f3;
        text-decoration: underline;
    }
}


</style>
